<template>
	<div style="height: auto;">
		<div class="content">
			<img src="../../assets/pic_price.png" class="top" />
			<div class="price">
				<div>
					<div class="price-base">
						一站式人力协作平台，智灵工助力伙伴轻装上阵
					</div>
					<div class="price_desc">
						选择适合您的版本
					</div>
					<div class="version">
						<div class="version_item">
							<div class="itemP1">
								<div class="item_title">免费版</div>
								<div class="item_desc">
									零门槛入门，体验人力管理核心价值
								</div>
							</div>
							<div class="item_content">
								<div class="item_day" style="text-align: center;">
									无期限
								</div>
								<div class="item_btn" @click="toBuy(0)">
									立即免费体验
								</div>
								<div class="mt30">
									免费版包括：
								</div>
								<div class="item_list">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="ml10">内部员工</div>
									<div class="list_num">20人</div>
								</div>
								<div class="item_list">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="ml10">用工单位</div>
									<div class="list_num">1个</div>
								</div>
								<div class="item_list">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="ml10">招聘岗位</div>
									<div class="list_num">2个</div>
								</div>
								<div class="item_list">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="ml10">招聘统计</div>
									<div class="list_num">不限</div>
								</div>
								<div class="item_bottom">
									无需付费即可完成人力管理核心流程的数字化转型，解决传统纸质记录混乱、统计低效的痛点，帮助用户建立基础人力管理认知，为后续升级打下基础
								</div>
							</div>
						</div>
						<div class="version_item">
							<div class="itemP4">
								<div class="item_title yellow">办证版</div>
								<div class="item_desc yellow" style="margin-top: 8px;">
									为合作伙伴提供优质服务支持，快速获得人力资源服务许可证
								</div>
							</div>
							<div class="item_content">
								<div>
									<span class="num">
										¥<span class="gradint-text4">2000.00</span>
									</span>
									元/3个月
								</div>
								<div class="item_btn" @click="toBuy(1)">
									立即购买
								</div>
								<div class="mt30">
									办证版包括
								</div>
								<div class="item_list">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="ml10">使用人数</div>
									<div class="list_num">30位</div>
								</div>
								<div class="item_list">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="ml10">员工档案</div>
									<div class="list_num">不限</div>
								</div>
								<div class="item_list">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="ml10">招聘岗位</div>
									<div class="list_num">500个</div>
								</div>
								<div class="item_list">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="ml10">门店管理</div>
									<div class="list_num">1个</div>
								</div>
								<div class="item_list">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="ml10">工资条</div>
									<div class="list_num">不限</div>
								</div>
								<div class="item_list">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="ml10">借款管理</div>
									<div class="list_num">不限</div>
								</div>
								<div class="item_list">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="ml10">发薪管理</div>
									<div class="list_num">不限</div>
								</div>
								<div class="item_list">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="ml10">互联网开票平台</div>
									<div class="list_num">不限</div>
								</div>
								<div class="item_bottom">
									专为人力资源服务机构及合作伙伴设计，提供完整的资质代办与合规支持服务，助力合作伙伴快速拓展业务范围，实现零门槛开展人力资源服务。
								</div>
							</div>
						</div>
						<div class="version_item">
							<div class="itemP2">
								<div class="item_title">标准版</div>
								<div class="item_desc">
									智能提效，支撑中小型企业规模化发展
								</div>
							</div>
							<div class="item_content">
								<div>
									￥
									<span class="item_day blueColor">6800.00 </span>
									元/年
								</div>
								<div class="item_btn"  @click="toBuy(1)">
									立即购买
								</div>
								<div class="mt30">
									包含免费版所有权益
								</div>
								<div class="item_list">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="ml10">内部员工</div>
									<div class="list_num">30人</div>
								</div>
								<div class="item_list">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="ml10">员工档案</div>
									<div class="list_num">不限</div>
								</div>
								<div class="item_list">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="ml10">招聘岗位</div>
									<div class="list_num">500个</div>
								</div>
								<div class="item_list">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="ml10">门店管理</div>
									<div class="list_num">1个</div>
								</div>
								<div class="item_list">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="ml10">工资条</div>
									<div class="list_num">不限</div>
								</div>
								<div class="item_list">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="ml10">借款管理</div>
									<div class="list_num">不限</div>
								</div>
								<div class="item_list">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="ml10">发薪管理</div>
									<div class="list_num">不限</div>
								</div>
								<div class="item_bottom">
									以高性价比解决小微企业“流程不规范、审批效率低、数据难统计”的核心痛点，实现人力管理从“数字化入门”到“标准化落地”的升级，助力团队聚焦业务增长。
								</div>
							</div>
						</div>
						<div class="version_item">
							<div class="itemP3">
								<div class="item_title yellow">高级版</div>
								<div class="item_desc yellow">
									战略定制，赋能大型企业创新共赢生态
								</div>
							</div>
							<div class="item_content">
								<div>
									<span class="num">
										¥<span class="gradint-text3">29800.00</span>
									</span>
									元/年
								</div>
								<div class="item_btn" @click="toBuy(1)">
									立即购买
								</div>
								<div class="mt30">
									包含标准版所有权益
								</div>
								<div class="item_list">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="ml10">宿舍管理</div>
									<div class="list_num">1个</div>
								</div>
								<div class="item_list">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="ml10">员工档案</div>
									<div class="list_num">不限</div>
								</div>
								<div class="item_list">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="ml10">借款管理</div>
									<div class="list_num">不限</div>
								</div>
								<div class="item_list">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="ml10">发薪管理</div>
									<div class="list_num">不限</div>
								</div>
								<div class="item_list">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="ml10">结算模板</div>
									<div class="list_num">不限</div>
								</div>
								<div class="item_list">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="ml10">智能算薪</div>
									<div class="list_num">不限</div>
								</div>
								<div class="item_list">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="ml10">招聘提成</div>
									<div class="list_num">不限</div>
								</div>
								<div class="item_list">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="ml10">日结岗位</div>
									<div class="list_num">不限</div>
								</div>
								<div class="item_bottom">
									通过智能工具替代重复人工操作，整合优质行业资源，实现人力管理从“标准化”到“精细化、高效化”的跨越，助力企业降低管理成本、提升人才储备质量，支撑规模化扩张
								</div>
							</div>
						</div>
					</div>
					<div class="versionOne">
						<div class="oneItem">
							<div class="oneTitle">私有化部署</div>
						</div>
						<div class="oneContent">
							<div class="oneLeft">
								<div class="gradint-text">
									详询报价
								</div>
								<div style="margin-top: 16px;font-size: 14px;color: #3d3d3d;">
									安全无忧的私有化部署专属人力资源管理平台
								</div>
								<div class="blue_btn" @click="showMsg">
									报价咨询
								</div>
							</div>
							<div class="oneRight">
								<div class="mt14 oneFlex">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="selfTitle ml10">数据主权完整掌控 - 企业核心人才数据100%存储于自有服务器，杜绝第三方访问风险</div>
								</div>
								<div class="mt14 oneFlex">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="selfTitle ml10">深度定制，贴合业务 - 告别"一刀切"的SaaS模式，根据企业组织架构、流程制度量身定制</div>
								</div>
								<div class="mt14 oneFlex">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="selfTitle ml10">性能无忧，稳定可靠 - 独立服务器资源保障系统高速响应，不受公有云平台流量波动影响，关键业务时段永不卡顿</div>
								</div>
								<div class="mt14 oneFlex">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="selfTitle ml10">灵活扩展，长期投资 - 按需扩容系统能力，一次性投入获得持续使用权，长期使用成本低于订阅模式</div>
								</div>
								<div class="mt14 oneFlex">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="selfTitle ml10">专属服务，快速响应 - 资深实施团队部署，7×10小时专属运维支持，问题响应速度提升300%</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="versionFlex">
					<div class="versionItem">
						<div class="flex1 textL">
							版本功能清单
						</div>
						<div class="flex1">
							免费版
						</div>
						<div class="flex1">
							办证版
						</div>
						<div class="flex1">
							标准版
						</div>
						<div class="flex1">
							高级版
						</div>
						<div class="flex1">
							私有化部署
						</div>
					</div>
					<div v-for="item,index in versionList" :style="!show && index >2 ?'display:none':''">
						<div class="versionItems">
							<div class="itemLeft">
								{{item.title}}
							</div>
						</div>
						<div class="itemTitle" v-for="val,key in item.list" >
							<div class="flex1 textL">
								{{val.key}}
							</div>
							<div class="flex1">
								{{val.v1}}
							</div>
							<div class="flex1">
								{{val.v4}}
							</div>
							<div class="flex1">
								{{val.v2}}
							</div>
							<div class="flex1">
								{{val.v3}}
							</div>
							<div class="flex1">
								{{val.v5}}
							</div>
						</div>
					</div>
				</div>
				<div class="showFlag" @click="changeLable">{{show?'收起对比':'展开对比'}}</div>
				<div class="mt59">
					<div class="server">
						增值服务
					</div>
					<div class="serverFlex" v-for="item,index in serverList">
						<div class="serveItem" v-for="val,key in item">
							<div class="flex">
								<img :src="val.img" class="serveIcon"/>
								<div class="textL ml12">
									<div class="serverTitle">{{val.title}}</div>
								</div>
							</div>
							<div class="serverDesc">
								{{val.desc}}
							</div>
							<div class="priceLeft mt38" v-if="val.price">
								<span class="red">{{val.price}}</span>{{val.unit}}
							</div>
							<div class="bgBtn" @click="toBuy(2)" v-if="val.btnFlag == 'buy'">{{val.btn}}</div>
							<div class="bgBtn" @click="showMsg()" v-else>{{val.btn}}</div>
						</div>
					</div>
				</div>
				<div class="mt59">
					<div class="server">
						常见问题
					</div>
					<div class="qa mt30">
						<div v-for="item,index in list" class="qaItem">
							<div @click="changeShow(index)">{{item.title}}</div>
							<div class="qaDesc mt10" v-if="item.show" >{{item.desc}}</div>
							<img src="../../assets/icon_xia.png" class="qaImg" v-if="item.show"/>
							<img src="../../assets/icon_you.png" class="qaImg" v-else/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'price',
	props: {
		showPop:false
	},
	data() {
		return {
			list:[
				{'title':'人力资源系统的购买价格包含哪些服务？是否有隐藏费用？','desc':'购买价格主要涵盖组织架构管理、员工档案、薪资计算等基础功能模块，同时包含在线客服、知识库等基础技术支持、管理员操作培训及用户手册；无隐藏费用，但需注意额增值服务，如付款渠道、简历资源、电子合同等高级功能模块，特殊需求的定制开发建议购买前在合同中明确所有费用项。',show:false},
				{'title':'购买前能否申请系统试用？试用期限是多久？','desc':'购买前可通过官网申请或联系销售免费试用，试用期通常为 60 天（部分可享 90 天），试用版仅开放基础模块，高级功能（算薪、发薪等）、数据录入量可能受限，且仅提供基础在线支持、专属顾问服务。',show:false},
				{'title':'系统上手难度如何？员工不懂操作有什么支持渠道？','desc':'系统上手难度较低，员工操作遇困可通过在线视频教程、操作手册与快速指南，后续还可通过工作日 8 小时在线客服、问题知识库获取支持，部分高级版本配备专属客户成功经理。',show:false},
				{'title':'系统后续的升级更新是否免费？升级频率如何？','desc':'系统升级更新政策因部署模式而异，SaaS 模式的订阅费已包含升级服务，安全补丁每月至少一次，功能更新 2-4 周一次，重大更新每季度或半年一次，通常在凌晨自动更新；本地部署系统的小版本 bug 修复多数免费，大版本功能升级一般按原 license 费用的 30% 收费，升级频率由企业自行决定（建议每季度常规维护）。',show:false},
				{'title':'不同版本（标准版 / 高级版）的核心区别是什么？如何选择适配版本？','desc':'标准版与高级版的核心区别体现在功能范围、数据管理、权限控制、风险防控、集成能力及价格上，标准版适合 1-50 人的小微企业；高级版适配 51-200 人的中型企业；200 人以上大型企业建议选择定制服务，选择时需明确核心需求、评估 1-3 年业务发展规模、做好预算规划并通过试用对比体验',show:false},
				{'title':'付款后多久能收到系统使用权限？','desc':'权限开通时间因付费方式与部署模式不同，SaaS 订阅在线支付通常 15 分钟内即时开通，线下付款需款项到账后 1-3 个工作日；本地部署则在合同签订并付款后 5-15 个工作日（含部署时间），管理员权限开通后立即生效。',show:false},
				{'title':'购买系统后如何申请开票？支持开哪种发票（专票 / 普票）？','desc':'发票申请可通过系统后台 “发票管理”提交电子发票申请，填写企业名称等信息后系统自动开具并发送至预留邮箱，纸质发票需联系客户经理或客服提交申请及资料，约 5-10 工作日寄送；系统支持增值税专用发票，发票内容通常为 “技术服务费” 或 “软件服务费”，电子发票与纸质发票具有同等法律效力可随时下载。',show:false},
			],
			serverList:[[
					{img:'https://cos.laborhub.cn/upload/program/icon_fukuan.png',title:'付款渠道',desc:'支持支付宝、微信、招商银行付款渠道',price:'500',unit:'元/个',btn:'立即购买',btnFlag:'buy'},
					{img:'https://cos.laborhub.cn/upload/program/icon_hetong.png',title:'合同套餐',desc:'真实有效，合规合法，满足多元签约需求',price:'1',unit:'元/份',btn:'立即购买',btnFlag:'buy'},
					{img:'https://cos.laborhub.cn/upload/program/icon_fukuan5.png',title:'简历公海',desc:'集中共享简历资源，助力高效人才匹配',price:'2',unit:'元/份',btn:'立即购买',btnFlag:'buy'}
				],[
					{img:'https://cos.laborhub.cn/upload/program/icon_fukuan1.png',title:'用人单位',desc:'依法招聘用工，保障劳动者合法权益',price:'500',unit:'元/个',btn:'立即购买',btnFlag:'buy'},
					{img:'https://cos.laborhub.cn/upload/program/icon_fukuan3.png',title:'招聘门店',desc:'就近招才，高效对接本地求职者',price:'500',unit:'元/个',btn:'立即购买',btnFlag:'buy'},
					{img:'https://cos.laborhub.cn/upload/program/icon_fukuan6.png',title:'宿舍管理',desc:'查看宿舍分配、床位状态及申请审核',price:'500',unit:'元/个',btn:'立即购买',btnFlag:'buy'}
				],[
					{img:'https://cos.laborhub.cn/upload/program/icon_fukuan2.png',title:'身份证识别',desc:'自动识别身份证信息，快速录入姓名、号码等关键数据',price:'0.05',unit:'元/次',btn:'立即购买',btnFlag:'buy'},
					{img:'https://cos.laborhub.cn/upload/program/icon_jianlishibie.png',title:'简历识别',desc:'智能解析简历附件，自动同步至简历库',price:'500',unit:'元/5000次',btn:'立即购买',btnFlag:'buy'},
					{img:'https://cos.laborhub.cn/upload/program/icon_dingzhi.png',title:'定制小程序/官网',desc:'量身定制小程序，适配需求赋能业务增长',price:'',unit:'',btn:'联系客服',btnFlag:'msg'}
				]
			],
			show:false,
			versionList:[
				{title:'招聘管理',list:[
					{key:'接单',v1:'不限',v2:'不限',v3:'不限',v4:'不限',v5:'不限'},
					{key:'简历公海',v1:'按需购买',v2:'按需购买',v3:'按需购买',v4:'按需购买',v5:'按需购买'},
					{key:'面试管理',v1:'不限',v2:'不限',v3:'不限',v4:'不限',v5:'不限'},
					{key:'录入记录',v1:'不限',v2:'不限',v3:'不限',v4:'不限',v5:'不限'},
				]},
				{title:'报表中心',list:[
					{key:'招聘统计表',v1:'不限',v2:'不限',v3:'不限',v4:'不限',v5:'不限'},
					{key:'招聘进展表',v1:'不限',v2:'不限',v3:'不限',v4:'不限',v5:'不限'},
					{key:'岗位进度表',v1:'不限',v2:'不限',v3:'不限',v4:'不限',v5:'不限'},
					{key:'简历投递渠道分析',v1:'不限',v2:'不限',v3:'不限',v4:'不限',v5:'不限'},
					{key:'朋友圈统计',v1:'不限',v2:'不限',v3:'不限',v4:'不限',v5:'不限'}
				]},
				{title:'客户管理',list:[
					{key:'用工单位',v1:'1个',v2:'10个',v3:'100个',v4:'10个',v5:'不限'},
					{key:'岗位列表',v1:'1个',v2:'500个',v3:'不限',v4:'500个',v5:'不限'}
				]},
				{title:'人事管理',list:[
					{key:'用人单位',v1:'--',v2:'1个',v3:'1个',v4:'1个',v5:'不限'},
					{key:'电子合同',v1:'按需购买',v2:'按需购买',v3:'按需购买',v4:'按需购买',v5:'按需购买'},
					{key:'宿舍管理',v1:'--',v2:'--',v3:'1个',v4:'--',v5:'不限'},
					{key:'住宿记录',v1:'--',v2:'不限',v3:'不限',v4:'不限',v5:'不限'},
					{key:'员工列表',v1:'不限',v2:'不限',v3:'不限',v4:'不限',v5:'不限'},
					{key:'员工档案',v1:'不限',v2:'不限',v3:'不限',v4:'不限',v5:'不限'},
					{key:'离职申请',v1:'不限',v2:'不限',v3:'不限',v4:'不限',v5:'不限'},
					{key:'供应商管理',v1:'--',v2:'不限',v3:'不限',v4:'不限',v5:'不限'},
					{key:'招聘顾问',v1:'不限',v2:'不限',v3:'不限',v4:'不限',v5:'不限'},
					{key:'黑名单',v1:'--',v2:'不限',v3:'不限',v4:'不限',v5:'不限'},
					{key:'门店管理',v1:'--',v2:'1个',v3:'3个',v4:'1个',v5:'不限'},
					{key:'保险理赔',v1:'--',v2:'不限',v3:'不限',v4:'不限',v5:'不限'},
					{key:'问题反馈',v1:'--',v2:'不限',v3:'不限',v4:'不限',v5:'不限'}
				]},
				{title:'考核培训',list:[
					{key:'内容管理',v1:'--',v2:'不限',v3:'不限',v4:'不限',v5:'不限'},
					{key:'题库',v1:'--',v2:'仅限手动出题',v3:'手动和AI出题',v4:'仅限手动出题',v5:'手动和AI出题'},
					{key:'考试记录',v1:'--',v2:'单独购买',v3:'不限',v4:'不限',v5:'不限'}
				]},
				{title:'财务管理',list:[
					{key:'结算模板',v1:'单独购买',v2:'单独购买',v3:'不限',v4:'单独购买',v5:'不限'},
					{key:'报销模板',v1:'--',v2:'--',v3:'不限',v4:'--',v5:'不限'},
					{key:'薪酬档案',v1:'单独购买',v2:'单独购买',v3:'不限',v4:'单独购买',v5:'不限'},
					{key:'智能算薪',v1:'单独购买',v2:'单独购买',v3:'不限',v4:'单独购买',v5:'不限'},
					{key:'招聘提成',v1:'单独购买',v2:'单独购买',v3:'不限',v4:'单独购买',v5:'不限'},
					{key:'报销记录',v1:'--',v2:'--',v3:'不限',v4:'--',v5:'不限'},
					{key:'借款管理',v1:'--',v2:'不限',v3:'不限',v4:'不限',v5:'不限'},
					{key:'发薪管理',v1:'--',v2:'不限',v3:'不限',v4:'不限',v5:'不限'},
					{key:'工作条',v1:'--',v2:'不限',v3:'不限',v4:'不限',v5:'不限'},
					{key:'财务统计',v1:'--',v2:'不限',v3:'不限',v4:'不限',v5:'不限'},
					{key:'企业码',v1:'按需配置',v2:'按需配置',v3:'按需配置',v4:'按需配置',v5:'按需购买'}
				]},
				{title:'灵活用工',list:[
					{key:'岗位管理',v1:'--',v2:'不限',v3:'不限',v4:'不限',v5:'不限'},
					{key:'用工记录',v1:'--',v2:'不限',v3:'不限',v4:'不限',v5:'不限'},
					{key:'结算管理',v1:'--',v2:'不限',v3:'不限',v4:'不限',v5:'不限'},
					{key:'充值记录',v1:'--',v2:'不限',v3:'不限',v4:'不限',v5:'不限'},
					{key:'申请开票',v1:'--',v2:'不限',v3:'不限',v4:'不限',v5:'不限'}
				]},
				{title:'服务与支持',list:[
					{key:'在线客服',v1:'工作日 09:00 - 18:30',v2:'工作日 09:00 - 18:30',v3:'工作日 09:00 - 18:30',v4:'工作日 09:00 - 18:30',v5:'7 * 10h'},
					{key:'1V1专属群服务',v1:'支持',v2:'支持',v3:'支持',v4:'支持',v5:'支持'},
					{key:'专家培训服务',v1:'--',v2:'线上培训',v3:'线上/上门培训',v4:'线上培训',v5:'线上/上门培训'}
				]},
			]
		};
	},
	created() {
	  
	},
	methods: {
		changeShow(index){
			this.list[index].show = !this.list[index].show;
		},
		toBuy(value){
			if(value == 0){
				var url = 'https://store.laborhub.cn/#/index';
			} else {
				var url = 'https://store.laborhub.cn/#/upgrade?web='+value;
			}
			window.open(url,'_blank');
		},
		showMsg(){
			this.$emit('pop',true);
		},
		changeLable(){
			this.show = !this.show;
			if(!this.show){
				document.querySelector(".versionFlex").scrollIntoView({behavior:'smooth',block:'start'});
			}
		}
	}
}
</script>

<style scoped>
@import './index.css';
</style>
